import FileGroupDialog from './FileGroupDialog'

export default FileGroupDialog
